import React from "react";
import Input from "../../ui/input";
import { Button } from "../../ui/button";

const SignupForm = ({ formData, errors, loading, onChange, onSubmit }) => {
  // Function to validate if a URL is a Shopify store link
  const isValidShopifyLink = (url) => {
    if (!url) return false;
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.hostname.includes(".myshopify.com");
    } catch (e) {
      return false;
    }
  };

  // Check if the Shopify store link is valid
  const isShopifyLinkValid = isValidShopifyLink(formData.shopifyStoreLink);

  return (
    <form onSubmit={onSubmit} className="mt-4 space-y-4">
      {/* Name Field */}
      <div className="space-y-2">
        <label
          htmlFor="name"
          className="block text-sm font-medium text-gray-700"
        >
          Full Name
        </label>
        <Input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={onChange}
          placeholder="John Doe"
          className={`block w-full px-4 py-2 border ${
            errors.name ? "border-red-500" : "border-gray-300"
          } rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm`}
        />
        {errors.name && (
          <p className="mt-1 text-sm text-red-500">{errors.name}</p>
        )}
      </div>

      {/* Email Field */}
      <div className="space-y-2">
        <label
          htmlFor="email"
          className="block text-sm font-medium text-gray-700"
        >
          Email Address
        </label>
        <Input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={onChange}
          placeholder="example@company.com"
          className={`block w-full px-4 py-2 border ${
            errors.email ? "border-red-500" : "border-gray-300"
          } rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm`}
        />
        {errors.email && (
          <p className="mt-1 text-sm text-red-500">{errors.email}</p>
        )}
      </div>

      {/* Password Field */}
      <div className="space-y-2">
        <label
          htmlFor="password"
          className="block text-sm font-medium text-gray-700"
        >
          Password
        </label>
        <Input
          type="password"
          id="password"
          name="password"
          value={formData.password}
          onChange={onChange}
          placeholder="Enter your password"
          className={`block w-full px-4 py-2 border ${
            errors.password ? "border-red-500" : "border-gray-300"
          } rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm`}
        />
        {errors.password && (
          <p className="mt-1 text-sm text-red-500">{errors.password}</p>
        )}
      </div>

      {/* Confirm Password Field */}
      <div className="space-y-2">
        <label
          htmlFor="confirmPassword"
          className="block text-sm font-medium text-gray-700"
        >
          Confirm Password
        </label>
        <Input
          type="password"
          id="confirmPassword"
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={onChange}
          placeholder="Confirm your password"
          className={`block w-full px-4 py-2 border ${
            errors.confirmPassword ? "border-red-500" : "border-gray-300"
          } rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm`}
        />
        {errors.confirmPassword && (
          <p className="mt-1 text-sm text-red-500">{errors.confirmPassword}</p>
        )}
      </div>

      {/* Shopify Store Link Field */}
      <div className="space-y-2">
        <label
          htmlFor="shopifyStoreLink"
          className="block text-sm font-medium text-gray-700"
        >
          Shopify Store Link
        </label>
        <Input
          type="text"
          id="shopifyStoreLink"
          name="shopifyStoreLink"
          value={formData.shopifyStoreLink}
          onChange={onChange}
          placeholder="https://your-store.myshopify.com"
          className={`block w-full px-4 py-2 border ${
            errors.shopifyStoreLink ? "border-red-500" : "border-gray-300"
          } rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm ${
            formData.shopifyStoreLink && !isShopifyLinkValid
              ? "border-red-500"
              : ""
          }`}
        />
        {errors.shopifyStoreLink && (
          <p className="mt-1 text-sm text-red-500">{errors.shopifyStoreLink}</p>
        )}
        {formData.shopifyStoreLink && !isShopifyLinkValid && (
          <p className="mt-1 text-sm text-red-500">
            Please enter a valid Shopify store URL (e.g.,
            https://your-store.myshopify.com)
          </p>
        )}
      </div>

      {/* Submit Button */}
      <Button
        type="submit"
        className="w-full px-4 py-2 text-white bg-red-600 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
        disabled={loading || (formData.shopifyStoreLink && !isShopifyLinkValid)}
      >
        {loading ? "Creating Account..." : "Sign Up"}
      </Button>
    </form>
  );
};

export default SignupForm;
